export const createSyncCacheKey = "/integrations/direct/cdi/import-syncs" as const;
export const updateSyncCacheKey = "/integrations/direct/cdi/import-syncs/:import_sync_id" as const;
export const updateSyncStatusCacheKey = "/integrations/direct/cdi/import-syncs/:import_sync_id/status" as const;
export const listSyncsCacheKey = "/integrations/direct/cdi/import-syncs" as const;
export const getSyncCacheKey = "/integrations/direct/cdi/import-syncs/:import_sync_id" as const;
export const postCdiTestConnectionCacheKey =
  "/integrations/direct/cdi/import-syncs/:import_sync_id/connection" as const;
export const postSnowflakeKeyRegenerateCacheKey =
  "/integrations/direct/cdi/import-keys/:key_id/regenerate" as const;
export const updateSnowflakeKeyCacheKey = "/integrations/direct/cdi/import-keys/:key_id/update" as const;

export const postSnowflakeDeleteKeyCacheKey = "/integrations/direct/cdi/import-keys/:key_id/delete" as const;
export const getSyncHistoryCacheKey = "/integrations/direct/cdi/import-syncs/:import_sync_id/sync_history" as const;
